import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";
import { Table, UNKNOWN, CommonExportUtil as Util } from "./CommonExportUtil";
import { Project } from "../../dao/Project";
import { Member } from "../../dao/Member";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";

export class F06_ExportManager {
  static Export_F06v0(
    common_form: UniForm,
    meta_table: UiMetaTable,
    answer_list: UniAnswer[],
    _Project: Project,
    sel_member_list: Member[]
  ): F06_ExportData[] {
    let export_list: F06_ExportData[] = [];

    for (const ans of answer_list) {
      let sel_ans_member = sel_member_list.find(
        (member) => member.guid === ans.member_guid
      ); //取得該ans的member資料

      let rhf_data = ans.ConvertToCommonRhfData();

      let export_data: F06_ExportData = new F06_ExportData();

      //#region 帶入基本資料
      export_data.填寫日期 = Util.填寫日期(ans);

      export_data.項次 = Util.項次();

      export_data.廠區 = Util.廠區(_Project);
      export_data.部門代號 = Util.部門代號();
      export_data.部門名稱 = Util.部門名稱(sel_ans_member);

      export_data.工號 = Util.工號(sel_ans_member);
      export_data.姓名 = Util.姓名(sel_ans_member);
      export_data.健檢日期 = Util.健檢日期(sel_ans_member);

      export_data.性別 = Util.性別(ans, sel_ans_member);
      //#endregion

      const rules: Table = {
        完全沒有: "0",
        輕微: "1",
        中等程度: "2",
        厲害: "3",
        非常厲害: "4",
      };

      export_data.Q1_睡眠困難 = Util.OptionValue(
        meta_table,
        rhf_data,
        "m01.睡眠困難，譬如難以入睡、易醒或早醒",
        UNKNOWN,
        rules
      ); // 1

      export_data.Q2_感覺緊張 = Util.OptionValue(
        meta_table,
        rhf_data,
        "m01.感覺緊張或不安",
        UNKNOWN,
        rules
      ); // 2

      export_data.Q3_覺得容易苦惱或動怒 = Util.OptionValue(
        meta_table,
        rhf_data,
        "m01.覺得容易苦惱或動怒",
        UNKNOWN,
        rules
      ); // 3

      export_data.Q4_感覺憂鬱_情緒低落 = Util.OptionValue(
        meta_table,
        rhf_data,
        "m01.感覺憂鬱、情緒低落",
        UNKNOWN,
        rules
      ); // 4

      export_data.Q5_覺得比不上別人 = Util.OptionValue(
        meta_table,
        rhf_data,
        "m01.覺得自己比不上別人",
        UNKNOWN,
        rules
      ); // 5

      export_data.EX_有自殺的想法 = Util.OptionValue(
        meta_table,
        rhf_data,
        "m01.有自殺的想法",
        UNKNOWN,
        rules
      ); // ex

      export_data.總分 = F06_ExportManager.計算總分(export_data);
      export_data.說明 = F06_ExportManager.顯示說明文字(export_data.總分);
      const suicide_score = Number(export_data.EX_有自殺的想法);

      if (!isNaN(suicide_score) && suicide_score >= 2) {
        export_data.說明 += "建議尋求專業輔導或精神科治療。";
      }

      export_list.push(export_data);
    }

    return export_list;
  }

  static 計算總分(export_data: F06_ExportData) {
    let score = 0;

    score += Number(export_data.Q1_睡眠困難);
    score += Number(export_data.Q2_感覺緊張);
    score += Number(export_data.Q3_覺得容易苦惱或動怒);
    score += Number(export_data.Q4_感覺憂鬱_情緒低落);
    score += Number(export_data.Q5_覺得比不上別人);

    if (isNaN(score)) {
      return UNKNOWN;
    } else {
      return String(Math.round(score));
    }
  }

  static 顯示說明文字(score: string) {
    let score_to_number_type = Number(score); // 轉成number型別
    if (isNaN(score_to_number_type)) {
      return UNKNOWN;
    } else if (score_to_number_type >= 0 && score_to_number_type <= 5) {
      return "表示身心適應狀況良好。";
    } else if (score_to_number_type >= 6 && score_to_number_type <= 9) {
      return "宜做壓力管理，建議找家人或朋友談談，抒發情緒。";
    } else if (score_to_number_type >= 10 && score_to_number_type <= 14) {
      return "宜做專業諮詢，建議尋求心理諮詢或接受專業諮詢。";
    } else if (score_to_number_type >= 15) {
      return "需高關懷，建議尋求專業輔導或精神醫療專業諮詢。";
    } else {
      throw new_ErrorAlert("486289 score 不在範圍內");
    }
  }
}

export class F06_ExportData {
  填寫日期 = "";

  項次 = "";

  廠區 = "";
  部門代號 = "";
  部門名稱 = "";

  工號 = "";
  姓名 = "";
  健檢日期 = "";

  性別 = "";

  //-----

  Q1_睡眠困難 = "";
  Q2_感覺緊張 = "";
  Q3_覺得容易苦惱或動怒 = "";
  Q4_感覺憂鬱_情緒低落 = "";
  Q5_覺得比不上別人 = "";
  總分 = "";

  //----

  EX_有自殺的想法 = "";
  說明 = "";
}
